import toastMessages from "./helpers/toastMessage";

const PROVIDER_TIMEOUT_MS = 3000;

const IP_PROVIDERS = [
  {
    url: "https://api.ipify.org?format=json",
    parse: (body: unknown) => (body as { ip?: string }).ip ?? null,
    responseType: "json" as const,
  },
  {
    url: "https://checkip.amazonaws.com",
    parse: (body: unknown) => (typeof body === "string" ? body.trim() : null),
    responseType: "text" as const,
  },
];

export async function fetchSourceIpFromProviders(): Promise<string | null> {
  for (const provider of IP_PROVIDERS) {
    try {
      const response = await fetch(provider.url, {
        signal: AbortSignal.timeout(PROVIDER_TIMEOUT_MS),
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const body =
        provider.responseType === "json"
          ? await response.json()
          : await response.text();
      const ip = provider.parse(body);
      if (ip) return ip;
    } catch (error) {
      toastMessages.error(`Failed to fetch IP from ${provider.url}`);
    }
  }
  return null;
}
